(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["grounding-earthing-sheet-guide-v3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const backToTopCleanup = new WeakMap();

    const initializeAccordion = (root) => {
      root.querySelectorAll('[data-ge-accordion-button]').forEach((button) => {
        if (button.dataset.geAccordionReady === 'true') return;

        button.dataset.geAccordionReady = 'true';
        button.addEventListener('click', () => {
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (!panel) return;

          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!isExpanded));
          panel.hidden = isExpanded;
        });
      });
    };

    const initializeBackToTop = (guide) => {
      const button = guide.querySelector('[data-ge-back-to-top]');
      if (!button || button.dataset.geBackToTopReady === 'true') return;

      const toggle = () => {
        button.classList.toggle('is-visible', window.scrollY > 520);
      };
      const scrollToTop = () => {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
      };
      const cleanup = () => {
        window.removeEventListener('scroll', toggle);
        button.removeEventListener('click', scrollToTop);
        button.dataset.geBackToTopReady = 'false';
        backToTopCleanup.delete(button);
      };

      button.dataset.geBackToTopReady = 'true';
      button.addEventListener('click', scrollToTop);
      window.addEventListener('scroll', toggle, { passive: true });
      backToTopCleanup.set(button, cleanup);
      toggle();
    };

    const initializeAll = (root) => {
      if (root.matches && root.matches('.ge-practical')) initializeAccordion(root);
      root.querySelectorAll('.ge-practical').forEach(initializeAccordion);
      if (root.matches && root.matches('.ge-guide')) initializeBackToTop(root);
      root.querySelectorAll('.ge-guide').forEach(initializeBackToTop);
    };

    const cleanupAll = (root) => {
      const buttons = [];
      if (root.matches && root.matches('[data-ge-back-to-top]')) buttons.push(root);
      root.querySelectorAll('[data-ge-back-to-top]').forEach((button) => buttons.push(button));
      buttons.forEach((button) => {
        const cleanup = backToTopCleanup.get(button);
        if (cleanup) cleanup();
      });
    };

    const start = () => initializeAll(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => cleanupAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["headwear-education-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('headwear-education-gallery')) {
    customElements.define(
      'headwear-education-gallery',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-gallery-track]');
          this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
          this.navigationSlides = this.slides.filter((slide) => slide.dataset.slideReady === 'true');

          if (this.navigationSlides.length === 0) {
            this.navigationSlides = this.slides;
          }

          this.previousButton = this.querySelector('[data-gallery-previous]');
          this.nextButton = this.querySelector('[data-gallery-next]');
          this.counter = this.querySelector('[data-gallery-counter]');

          if (!this.track || this.slides.length === 0) return;

          this.currentIndex = 0;
          this.frame = null;
          this.handleScroll = this.handleScroll.bind(this);
          this.handlePrevious = this.handlePrevious.bind(this);
          this.handleNext = this.handleNext.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.handleBlockSelect = this.handleBlockSelect.bind(this);

          this.track.addEventListener('scroll', this.handleScroll, { passive: true });
          this.previousButton?.addEventListener('click', this.handlePrevious);
          this.nextButton?.addEventListener('click', this.handleNext);
          this.track.addEventListener('keydown', this.handleKeydown);
          document.addEventListener('shopify:block:select', this.handleBlockSelect);

          this.updateNavigation();
        }

        disconnectedCallback() {
          this.track?.removeEventListener('scroll', this.handleScroll);
          this.previousButton?.removeEventListener('click', this.handlePrevious);
          this.nextButton?.removeEventListener('click', this.handleNext);
          this.track?.removeEventListener('keydown', this.handleKeydown);
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);

          if (this.frame) cancelAnimationFrame(this.frame);
        }

        handleScroll() {
          if (this.frame) cancelAnimationFrame(this.frame);

          this.frame = requestAnimationFrame(() => {
            this.currentIndex = this.getClosestSlideIndex();
            this.updateNavigation();
          });
        }

        handlePrevious() {
          this.goToSlide(this.currentIndex - 1);
        }

        handleNext() {
          this.goToSlide(this.currentIndex + 1);
        }

        handleKeydown(event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.handlePrevious();
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.handleNext();
          } else if (event.key === 'Home') {
            event.preventDefault();
            this.goToSlide(0);
          } else if (event.key === 'End') {
            event.preventDefault();
            this.goToSlide(this.navigationSlides.length - 1);
          }
        }

        handleBlockSelect(event) {
          const slide = event.target.closest('[data-gallery-slide]');

          if (!slide || !this.contains(slide)) return;

          this.scrollToSlide(slide, true);

          const navigationIndex = this.navigationSlides.indexOf(slide);
          if (navigationIndex > -1) {
            this.currentIndex = navigationIndex;
            this.updateNavigation();
          }
        }

        getClosestSlideIndex() {
          const trackBounds = this.track.getBoundingClientRect();
          const trackCenter = trackBounds.left + trackBounds.width / 2;
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          this.navigationSlides.forEach((slide, index) => {
            const slideBounds = slide.getBoundingClientRect();
            const slideCenter = slideBounds.left + slideBounds.width / 2;
            const distance = Math.abs(slideCenter - trackCenter);

            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          return closestIndex;
        }

        goToSlide(index, immediate = false) {
          const nextIndex = Math.max(0, Math.min(index, this.navigationSlides.length - 1));
          const slide = this.navigationSlides[nextIndex];

          if (!slide) return;

          this.scrollToSlide(slide, immediate);
          this.currentIndex = nextIndex;
          this.updateNavigation();
        }

        scrollToSlide(slide, immediate = false) {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          this.track.scrollTo({
            left: slide.offsetLeft,
            behavior: immediate || reduceMotion ? 'auto' : 'smooth'
          });
        }

        updateNavigation() {
          if (this.previousButton) this.previousButton.disabled = this.currentIndex === 0;
          if (this.nextButton) {
            this.nextButton.disabled = this.currentIndex === this.navigationSlides.length - 1;
          }
          if (this.counter) {
            this.counter.textContent = `${this.currentIndex + 1} / ${this.navigationSlides.length}`;
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silver-color-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('silver-color-comparison-slider')) {
    customElements.define('silver-color-comparison-slider', class extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('[data-silver-color-range]');

        if (!this.range) {
          return;
        }

        this.updatePosition = () => {
          const position = `${this.range.value}%`;
          const frontLabel = this.range.dataset.frontLabel || 'Front Side';
          this.style.setProperty('--silver-color-position', position);
          this.range.setAttribute('aria-valuetext', `${position} ${frontLabel} visible`);
        };

        this.setPosition = (value) => {
          const minimum = Number(this.range.min) || 0;
          const maximum = Number(this.range.max) || 100;
          const nextValue = Math.min(maximum, Math.max(minimum, Math.round(value)));

          this.range.value = String(nextValue);
          this.range.dispatchEvent(new Event('input', { bubbles: true }));
        };

        this.updateFromPointer = (event) => {
          const bounds = this.range.getBoundingClientRect();
          let ratio = (event.clientX - bounds.left) / bounds.width;

          if (getComputedStyle(this.range).direction === 'rtl') {
            ratio = 1 - ratio;
          }

          this.setPosition(ratio * 100);
        };

        this.onPointerDown = (event) => {
          this.pointerActive = true;
          this.range.setPointerCapture?.(event.pointerId);
          this.updateFromPointer(event);
        };

        this.onPointerMove = (event) => {
          if (this.pointerActive) {
            this.updateFromPointer(event);
          }
        };

        this.onPointerUp = (event) => {
          this.pointerActive = false;

          if (this.range.hasPointerCapture?.(event.pointerId)) {
            this.range.releasePointerCapture(event.pointerId);
          }
        };

        this.onKeyDown = (event) => {
          const currentValue = Number(this.range.value);
          const step = Number(this.range.step) || 1;
          let nextValue = currentValue;

          if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
            nextValue -= step;
          } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
            nextValue += step;
          } else if (event.key === 'Home') {
            nextValue = Number(this.range.min) || 0;
          } else if (event.key === 'End') {
            nextValue = Number(this.range.max) || 100;
          } else {
            return;
          }

          event.preventDefault();
          this.setPosition(nextValue);
        };

        this.range.addEventListener('input', this.updatePosition);
        this.range.addEventListener('pointerdown', this.onPointerDown);
        this.range.addEventListener('pointermove', this.onPointerMove);
        this.range.addEventListener('pointerup', this.onPointerUp);
        this.range.addEventListener('pointercancel', this.onPointerUp);
        this.range.addEventListener('keydown', this.onKeyDown);
        this.updatePosition();
      }

      disconnectedCallback() {
        if (this.range && this.updatePosition) {
          this.range.removeEventListener('input', this.updatePosition);
          this.range.removeEventListener('pointerdown', this.onPointerDown);
          this.range.removeEventListener('pointermove', this.onPointerMove);
          this.range.removeEventListener('pointerup', this.onPointerUp);
          this.range.removeEventListener('pointercancel', this.onPointerUp);
          this.range.removeEventListener('keydown', this.onKeyDown);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silver-patina-comparison-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('silver-patina-slider-v2')) {
    customElements.define('silver-patina-slider-v2', class extends HTMLElement {
      connectedCallback() {
        this.control = this.querySelector('[data-comparison-control]');

        if (!this.control) {
          return;
        }

        this.position = Number(this.dataset.initialPosition) || 50;
        this.pointerActive = false;

        this.setPosition = (value) => {
          const nextPosition = Math.min(100, Math.max(0, Math.round(value)));
          this.position = nextPosition;
          this.style.setProperty('--sfv2-patina-position', `${nextPosition}%`);
          this.control.setAttribute('aria-valuenow', String(nextPosition));
          this.control.setAttribute('aria-valuetext', `${nextPosition}% reference sample visible`);
        };

        this.updateFromPointer = (event) => {
          const bounds = this.control.getBoundingClientRect();
          let ratio = (event.clientX - bounds.left) / bounds.width;

          if (getComputedStyle(this.control).direction === 'rtl') {
            ratio = 1 - ratio;
          }

          this.setPosition(ratio * 100);
        };

        this.onPointerDown = (event) => {
          if (event.button !== undefined && event.button !== 0) {
            return;
          }

          this.pointerActive = true;
          this.control.setPointerCapture?.(event.pointerId);
          this.updateFromPointer(event);
          event.preventDefault();
        };

        this.onPointerMove = (event) => {
          if (!this.pointerActive) {
            return;
          }

          this.updateFromPointer(event);
          event.preventDefault();
        };

        this.onPointerUp = (event) => {
          this.pointerActive = false;

          if (this.control.hasPointerCapture?.(event.pointerId)) {
            this.control.releasePointerCapture(event.pointerId);
          }
        };

        this.onKeyDown = (event) => {
          const increment = event.shiftKey ? 10 : 1;
          let nextPosition = this.position;

          if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
            nextPosition -= increment;
          } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
            nextPosition += increment;
          } else if (event.key === 'Home') {
            nextPosition = 0;
          } else if (event.key === 'End') {
            nextPosition = 100;
          } else {
            return;
          }

          event.preventDefault();
          this.setPosition(nextPosition);
        };

        this.control.addEventListener('pointerdown', this.onPointerDown);
        this.control.addEventListener('pointermove', this.onPointerMove);
        this.control.addEventListener('pointerup', this.onPointerUp);
        this.control.addEventListener('pointercancel', this.onPointerUp);
        this.control.addEventListener('keydown', this.onKeyDown);
        this.setPosition(this.position);
      }

      disconnectedCallback() {
        if (!this.control) {
          return;
        }

        this.control.removeEventListener('pointerdown', this.onPointerDown);
        this.control.removeEventListener('pointermove', this.onPointerMove);
        this.control.removeEventListener('pointerup', this.onPointerUp);
        this.control.removeEventListener('pointercancel', this.onPointerUp);
        this.control.removeEventListener('keydown', this.onKeyDown);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silver-patina-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('silver-patina-slider')) {
    customElements.define('silver-patina-slider', class extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('[data-silver-patina-range]');

        if (!this.range) {
          return;
        }

        this.updatePosition = () => {
          const position = `${this.range.value}%`;
          this.style.setProperty('--silver-patina-position', position);
          this.range.setAttribute('aria-valuetext', `${position} reference sample visible`);
        };

        this.setPosition = (value) => {
          const minimum = Number(this.range.min) || 0;
          const maximum = Number(this.range.max) || 100;
          const nextValue = Math.min(maximum, Math.max(minimum, Math.round(value)));

          this.range.value = String(nextValue);
          this.range.dispatchEvent(new Event('input', { bubbles: true }));
        };

        this.updateFromPointer = (event) => {
          const bounds = this.range.getBoundingClientRect();
          let ratio = (event.clientX - bounds.left) / bounds.width;

          if (getComputedStyle(this.range).direction === 'rtl') {
            ratio = 1 - ratio;
          }

          this.setPosition(ratio * 100);
        };

        this.onPointerDown = (event) => {
          this.pointerActive = true;
          this.range.setPointerCapture?.(event.pointerId);
          this.updateFromPointer(event);
        };

        this.onPointerMove = (event) => {
          if (this.pointerActive) {
            this.updateFromPointer(event);
          }
        };

        this.onPointerUp = (event) => {
          this.pointerActive = false;

          if (this.range.hasPointerCapture?.(event.pointerId)) {
            this.range.releasePointerCapture(event.pointerId);
          }
        };

        this.onKeyDown = (event) => {
          const currentValue = Number(this.range.value);
          const step = Number(this.range.step) || 1;
          let nextValue = currentValue;

          if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
            nextValue -= step;
          } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
            nextValue += step;
          } else if (event.key === 'Home') {
            nextValue = Number(this.range.min) || 0;
          } else if (event.key === 'End') {
            nextValue = Number(this.range.max) || 100;
          } else {
            return;
          }

          event.preventDefault();
          this.setPosition(nextValue);
        };

        this.range.addEventListener('input', this.updatePosition);
        this.range.addEventListener('pointerdown', this.onPointerDown);
        this.range.addEventListener('pointermove', this.onPointerMove);
        this.range.addEventListener('pointerup', this.onPointerUp);
        this.range.addEventListener('pointercancel', this.onPointerUp);
        this.range.addEventListener('keydown', this.onKeyDown);
        this.updatePosition();
      }

      disconnectedCallback() {
        if (this.range && this.updatePosition) {
          this.range.removeEventListener('input', this.updatePosition);
          this.range.removeEventListener('pointerdown', this.onPointerDown);
          this.range.removeEventListener('pointermove', this.onPointerMove);
          this.range.removeEventListener('pointerup', this.onPointerUp);
          this.range.removeEventListener('pointercancel', this.onPointerUp);
          this.range.removeEventListener('keydown', this.onKeyDown);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
